import { lazy } from "react"

export const Rations = lazy(() => import("./rations"))
